import isConnected from "js/core/utilities/isConnected";

export async function fetchAndTrackOfflineStatus(
    input: RequestInfo | URL, // eslint-disable-line no-undef
    init?: RequestInit, // eslint-disable-line no-undef
    {
        isOnline = () => undefined
    }: {
        /** Derives the online status from the status code, return undefined to keep online status unchanged */
        isOnline?: (status: number) => boolean | undefined;
    } = {}
) {
    let online: boolean | undefined;
    try {
        let response: Response;
        try {
            response = await fetch(input, init);
        } catch (err) {
            if (isFailedToFetchError(err)) {
                // fetch() failed with a "Failed to fetch" error, so we're offline or the server is unreachable
                online = false;
            }

            // Some other error (e.g. bad argument), rethrow and assume offline status is unchanged
            throw err;
        }

        online = isOnline(response.status);

        return response;
    } finally {
        if (online !== undefined) {
            isConnected.triggerIsOnlineChange(online);
        }
    }
}

export function isFailedToFetchError(error: unknown) {
    return error instanceof TypeError && ["failed to fetch", "load failed", "networkerror when attempting to fetch resource."].includes(error.message.toLowerCase());
}
